import Base2Repository from "./base2.repository";
import { GenericPersistence } from "core/data/persistence";
import { GenericService } from "core/data/service";

class DevolutionReportRepository extends Base2Repository {
  getPersistenceProvider() {
    return new GenericPersistence(this.getEntityIdentifier());
  }

  getServiceProvider() {
    return new GenericService({});
  }

  async getDevolutionReport(filters) {
    const result = await this.get("/v1/devolutions_reports", {
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user,
      page: filters.page,
      count: filters.count,
      order: filters.order
    });
    return result;
  }

  async getDevolutionTotal(filters) {
    const result = await this.get("/v1/devolutions_reports_totals", {
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user
    });
    return result;
  }

  async getDevolutionReportCSV(filters) {
    const result = await this.get("/v1/devolutions_reports", {
      from: filters.from,
      to: filters.to,
      salesman_uuid: filters.user,
      page: 1,
      count: 99999,
      order: filters.order
    });
    return result;
  }
}

export default new DevolutionReportRepository();



// WEBPACK FOOTER //
// ./src/core/repository/devolution-report.repository.js